// extracted by mini-css-extract-plugin
export default {"red":"Timer_red__ze7XW","blue":"Timer_blue__Ouzr7","grey":"Timer_grey__6i0H3","times":"Timer_times__pgZtL","timeBox":"Timer_timeBox__qkce5","colons":"Timer_colons__OnMkX"};